import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import React, { useEffect, useState } from 'react';

// MESSAGES

// REQUESTS
import useSettingsRequest from '../../../requests/SettingsRequest';

const MfaVerificationDialog = ({
  option,
  username,
  authenticatorCode,
  show,
  onHide,
  errorHandler,
}) => {
  const { verifyMfa } = useSettingsRequest();

  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [url, setUrl] = useState('');

  useEffect(() => {
    setShowDialog(show);
  }, [show]);

  useEffect(() => {
    if (username && authenticatorCode) {
      setUrl(
        `otpauth://totp/${encodeURIComponent(
          username
        )}?secret=${authenticatorCode}&issuer=CompleteSMS`
      );
    }
  }, [username, authenticatorCode]);

  const hide = (e) => {
    e.stopPropagation();

    setShowDialog(false);
    onHide();
  };

  const verify = async (e) => {
    e.stopPropagation();

    setLoading(true);

    const result = await verifyMfa(option, code, errorHandler);

    if (result.ok) {
      setLoading(false);
      setShowDialog(false);
      onHide();
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog open={showDialog} onClose={hide}>
      <DialogTitle>Verify Multi-Factor Authentication</DialogTitle>
      <DialogContent>
        <Stack sx={{ gap: 2 }}>
          {option === 'A' ? (
            <Stack sx={{ gap: 2 }}>
              <Typography>
                Please enter the code from your authenticator application to
                enable multi-factor authentication.
              </Typography>
              <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
                {url && <QRCodeSVG value={url} />}
              </Stack>
            </Stack>
          ) : (
            <Stack>
              <Typography>
                Please enter the code sent to you via{' '}
                {option === 'S' ? 'SMS' : 'Email'}.
              </Typography>
            </Stack>
          )}

          <Stack
            sx={{
              flexDirection: { md: 'row' },
              columnGap: 2,
              alignItems: { md: 'center' },
            }}
          >
            <TextField
              size="small"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              fullWidth
              variant="outlined"
              label="Code"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  e.stopPropagation();
                  verify();
                }
              }}
              autoFocus
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          variant="text"
          onClick={hide}
          sx={{
            textTransform: 'none',
            textDecoration: 'underline',
            fontWeight: 400,
          }}
        >
          Cancel
        </Button>
        <Button
          color="secondary"
          variant="contained"
          disabled={loading}
          onClick={verify}
        >
          {loading ? 'Saving ...' : 'Next'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MfaVerificationDialog;
